import React from "react";
import "rc-tooltip/assets/bootstrap.css";
import Utils from "../../../../lib/utils";

import JobIcons from "./JobIcons";
import SecondarySection from "./SecondarySection";

import { Container, Title, Details, HeaderContainer, Link } from "./style.ts";

const Header = (props) => {
  const { job, user, address, trim } = props;
  return (
    <Container>
      <HeaderContainer>
        <Title>
          <span style={{ display: "inline-block", marginRight: 20 }}>
            {trim(job.title, 120)}
          </span>
          {Utils.isEmployer(user) && job.owner_id === user.id && (
            <Link href={`/jobs/${job.slug}/edit`}>
              <span style={{ fontSize: "0.6em" }}>Edit</span>
            </Link>
          )}
          <Details>
            <JobIcons {...job} address={address} />
          </Details>
        </Title>
        <SecondarySection {...props} />
      </HeaderContainer>
    </Container>
  );
};

export default Header;
